import { LitheElement, LitheFC } from '@wheelbox/lithejs-engine';

const RoutingExample: LitheFC = (): LitheElement<'section'> => {
  return ['section', ['h2', 'Routing Example']];
};

export default RoutingExample;
